export default {
  namespaced: true,

  state: {
    errorList: []
  },
  getters: {},
  actions: {
    async queryError(
      { dispatch, commit, getters, rootGetters, state, rootState },
      data = {}
    ) {
      let res = await rootState.axios.post(
        "/server/portal/test/queryError",
        data
      );
      commit("setErrorList", res.data.data);
    }
  },

  mutations: {
    setErrorList(state, data) {
      state.errorList = data;
    }
  }
};
